import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import FilterInput from './filter-input';
import FilterSlider from './filter-slider';
import Tooltip from 'components/atoms/tooltip';
import {RangeLimits} from 'components/organisms/range-of-outcomes/helpers';

class RangeOfOutcomesComponent extends Component {
    render() {
        const {useDragging, config} = this.props;
        const rangeLimits = new RangeLimits(config.sport);

        return (
            <div>
                <strong className="filter-title">
                    <Tooltip subject="Setting this number to 5 will apply a ±5% randomization to the players' projections for every lineup generated." />
                    Randomization %
                </strong>
                <div className="range-holder">
                    <div className="slider-wrap">
                        <FilterSlider
                            rangeLimits={rangeLimits}
                            step={1}
                            sport={config.sport}
                            useDragging={useDragging}
                        />
                    </div>
                    <div className="range-wrap">
                        <FilterInput rangeLimits={rangeLimits} sport={config.sport} testId="randomization-input" />
                    </div>
                </div>
            </div>
        );
    }
}

export default RangeOfOutcomesComponent;
